<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre_15" id="calibre_pb_22"><span class="calibre10">TIME AND SPACE</span></h2>
<h2 class="calibre_22" id="filepos65673"><span class="calibre10"><span class="italic1">4 <img alt="image" class="calibre11" src="images/00004.jpg"/> Time and Movement Are Two Aspects of a Single Phenomenon</span></span></h2><div class="calibre_14"> </div>
<h3 class="calibre_23" id="filepos65875"><span class="calibre12"><span class="italic1">Portrait of a Gentleman</span></span></h3><div class="calibre_14"> </div>
<p class="calibre_19"><span class="calibre5">We are vortices whose centre is a point that is motionless and eternal but which appears in manifestation as motion which increases in velocity in the manner of a whirlpool or <a></a>tornado (whose epicentre is still) from nucleus to periphery.</span></p>
<p class="calibre_19"><span class="calibre5">But the nucleus is in Reality, whereas the vortex is phenomenon in the form of a multi-dimensional force-field.</span></p>
<p class="calibre_19"><span class="calibre5">The periphery of this force-field appears as matter, of various densities, extended in space and moving in time at divers velocities.</span></p>
<p class="calibre_19"><span class="calibre5">The totality of this appearance partakes of the consciousness which is its core and only reality.</span></p> <div class="mbp_pagebreak" id="calibre_pb_23"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_014.vue?0a9b5d26